import * as React from 'react'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export function EventChapterPicker({
  chapters,
  value,
  onChange,
}: {
  chapters: { id: number; name: string }[]
  value: number | null
  onChange: (value: number | null) => void
}) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor="event-chapter">Chapter</Label>
      <Select
        value={value ? String(value) : 'none'}
        onValueChange={(next) => onChange(next === 'none' ? null : Number(next))}
      >
        <SelectTrigger id="event-chapter">
          <SelectValue placeholder="No chapter" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No chapter</SelectItem>
          {chapters.map((chapter) => (
            <SelectItem key={chapter.id} value={String(chapter.id)}>
              {chapter.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export function EventChapterField({
  chapters,
  value,
  onChange,
}: {
  chapters: { id: number; name: string }[]
  value: number | null
  onChange: (value: number | null) => void
}) {
  return (
    <div className="grid gap-2 px-4 py-3 sm:grid-cols-[148px_minmax(0,1fr)] sm:items-start">
      <Label className="pt-1.5 text-caption text-muted-foreground">Chapter</Label>
      <EventChapterPicker chapters={chapters} value={value} onChange={onChange} />
    </div>
  )
}
